import { writable } from "svelte/store";

export const controlPanelOpen = writable(false);
